import { useEffect, useState } from "react";
import { WelcomeModal } from "../../Pages/Auth/signup/signup.styles"
import TermsAndConditions from "../../Pages/Public/terms-and-conditions/TermsAndConditions"
import Button from "../button/button.component"
import Image from "../image/image.component";

const TermsModal = ({open, onClose}) => {
    const [openTerms, setOpenTerms] = useState(false);
    const handleOpenTerms = () => setOpenTerms(true);
    const handleCloseTerms = () => setOpenTerms(false);

    const handleClose = () => {
        onClose.call(this);
    } 

    useEffect(() => {
        if(open) {
            handleOpenTerms();

        }
        else {
            handleCloseTerms();
        }
    }, [open]);

    return (
        <WelcomeModal open={openTerms} onClose={() => handleClose()}>
            <div className="title">
                <Image src={'logo.png'} alt={'Music Bull'} width={150} />
                <h2 >Terms and Conditions</h2>
            </div>
            <TermsAndConditions isPopup />
            <div className="button-container">
                <Button color="blue" onClick={() => handleClose()}>Close</Button>
            </div>
        </WelcomeModal>
    )
}

export default TermsModal;